import { memo } from 'react';
import { useTheme } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useToggle } from '@dfl/hook-utils';
import { IconButton } from '@dfl/mui-react-common';
import { useTranslation } from 'react-i18next';
import { StyledBadge } from './tooltip.styled';
import { useNotificationCount } from '../../hooks/useNotificationCount';
import { useNotificationSound } from '../../hooks/useNotificationSound';
import { NotificationDrawer } from '../NotificationDrawer';

const NotificationTooltipContent = () => {
  const { t } = useTranslation('common');
  const { isOpen, onOpen, onClose } = useToggle(false);
  const theme = useTheme();

  const { isSoundEnabled, toggleSound } = useNotificationSound();

  // Use React Query for notification count
  const { count } = useNotificationCount();

  return (
    <>
      <IconButton tooltip={t('common:notification')} onClick={onOpen}>
        <StyledBadge badgeContent={count?.total} color='primary' invisible={!count}>
          <NotificationsIcon
            sx={{
              color: count ? theme.palette.grey[900] : theme.palette.primary.main,
            }}
          />
        </StyledBadge>
      </IconButton>

      <NotificationDrawer
        open={isOpen}
        onClose={onClose}
        isSoundEnabled={isSoundEnabled}
        onToggleSound={toggleSound}
      />
    </>
  );
};

export default memo(NotificationTooltipContent);
